import { useState } from 'react';
import Header from '../../components/Header';
import axios from '../../util/Axios';
import { Paper, TextField, Button } from '@mui/material';
import { Link } from 'react-router-dom';


function ForgotPassword() {
  const [email, setEmail] = useState('');

  const handleForgotPass = () => {
    axios
      .post('/users/forgotpass', {
        email: email
      })
      .then(() => {
        setEmail('');
      });
  }

  return (
    <>
      <Header logged={false} />

      <Paper
        sx={{
          margin: 'auto',
          marginTop: '160px',
          maxWidth: '500px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '24px'
        }}
      >
        <p style={{ margin: 0 }}>We will send you an email with instructions on how to reset your password.</p>
        <TextField label="Email" value={email} onChange={(event) => setEmail(event.target.value)} />
        <Button variant="contained" color="primary" onClick={handleForgotPass}>
          Send Email
        </Button>
        <Link to={'/login'} style={{ alignSelf: 'center' }}>Return to Login</Link>
      </Paper>
    </>
  )
}

export default ForgotPassword;